import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/api";
import { RootObjectOrganization, RootObjectOrganizations } from "../../types/allorganization";
import { OrgTypeResponse } from "../../types/orgType";


export const getOrganizationById = createAsyncThunk<
  RootObjectOrganization,          
  string | number,           
  { rejectValue: string }    
>(
  "organization/getOrganizationById",
  async (organizationId, { rejectWithValue }) => {
    try {
      const response = await api.get(`org/get-by-Id?Id=${organizationId}`);

      if (response.data) {
        return response.data as RootObjectOrganization;
      } else {
        console.error(response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getOrganizationsByContactId = createAsyncThunk<
  RootObjectOrganizations,          
  void,           
  { rejectValue: string }    
>(
  "organization/getOrganizationsByContactId",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`org/get-by-contactId`);

      if (response.data) {
        return response.data as RootObjectOrganizations;
      } else {
        console.error(response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getOrgTypeById = createAsyncThunk<
  OrgTypeResponse,          
  string | number,           
  { rejectValue: string }    
>(
  "organization/getOrgTypeById",
  async (orgTypeId, { rejectWithValue }) => {
    try {
      const response = await api.get(`org/getOrgTypeById?Id=${orgTypeId}`);

      if (response.data) {
        return response.data.Data as OrgTypeResponse;
      } else {
        console.error(response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
